/* eslint-disable react-hooks/exhaustive-deps */
import { IconChevronLeft, IconDownload } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ListView from "../../components/common/ListView";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import CopyButton from "../../components/CopyButton";
import {
  useCreateSallaOrderMutation,
  useSallaPendingData,
} from "../../apis/integrationApis";
import { useEffect, useState } from "react";
import useDebounce from "../../utilities/useDebounce";
import formatDate from "../../utilities/helper";
import Pagination from "../../components/common/Pagination";
import toast from "react-hot-toast";

export default function PendingOrders() {
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo]);
  const { data, refetch } = useSallaPendingData(1, searchFor);
  const { mutate } = useCreateSallaOrderMutation();
  const navigate = useNavigate();

  const handleCreate = (orderId: any) => {
    mutate(
      { orderId },
      {
        onSuccess: () => {
          refetch();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-3">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="flex justify-center items-center rounded-full h-10 w-10 sm:h-12 sm:w-12 bg-white border border-[#D8D8D8]"
          >
            <IconChevronLeft size={20} />
          </button>
          <h1 className="text-xl sm:text-2xl md:text-3xl  text-[#212121]">
            Pending Orders
          </h1>
        </div>
      </div>

      <div className="rounded-3xl">
        <div className="flex items-start">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
            <h1 className="text-3xl text-[#212121]">Salla Order List</h1>
            <div className="flex items-center gap-2">
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              viewBox="0 0 34 34"
              fill="none"
              className="absolute -bottom-[12.5px] -left-[22.5px] rotate-[2deg] "
            >
              <path
                d="M0.5 0.5C4.94768 14.4784 15.2221 25.8511 28.6786 31.6907L34 34H2.31268L0.5 0.5Z"
                fill="#F7F6F2"
              />
            </svg>

            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {" "}
          <ListView
            data={data?.orders}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "#", render: (_, i) => i + 1 },
              {
                label: "Ref Numbers",
                render: (c) => c.referenceNo,
              },
              {
                label: "Order Id",
                render: (c) => c.orderId,
              },
              {
                label: "Order Request",
                render: (c: any) => (
                  <p className="flex items-center  w-fit gap-2  bg-white py-0.5 px-2 border border-[#D2D2D2] rounded">
                    <span className="truncate">
                      {" "}
                      {(() => {
                        const jsonString = JSON.stringify(c.orderData);
                        return jsonString.length > 50
                          ? jsonString.slice(0, 50) + "..."
                          : jsonString;
                      })()}
                    </span>
                    <CopyButton text={JSON.stringify(c.orderData)} />
                  </p>
                ),
              },
              {
                label: "Date",
                render: (c) => formatDate(c.createdAt),
              },
              {
                label: "Actions",
                render: (c: any) => {
                  const isCreated = c.status === "created";

                  return (
                    <button
                      className={`px-4 w-24 py-2 rounded-full cursor-pointer 
          ${
            isCreated
              ? "bg-[#20BF55] text-white"
              : "bg-[#FBD037] group-hover:bg-white text-[#212121]"
          }`}
                      onClick={() => {
                        handleCreate(c?.id);
                      }}
                      disabled={isCreated || c.reqStatus === "PENDING"}
                    >
                      {isCreated ? "Created" : "Create"}
                    </button>
                  );
                },
              },
            ]}
          />
          {data?.totalPages > 1 && (
            <Pagination
              currentPage={pageNo}
              totalPages={data.totalPages}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
      </div>
    </div>
  );
}
